module.exports = __webpack_public_path__ + "static/media/onboardingShipments.35e81270.png";